// extracted by mini-css-extract-plugin
export default {"root":"v3cO_XOW3RRneyczoSax"};